const EN_US = {
  'foodstormDomain.title': 'Foodstorm',
  'foodstormDomain.educationalBanner.heading':
    'Do you offer prepared foods, catering, made-to-order meals, deli or bakery pre-orders?',
  'foodstormDomain.educationalBanner.information':
    "FoodStorm is Instacart's built-for-grocery order management system that serves all these use cases and more.",
  'foodstormDomain.educationalBanner.buttonText': 'Explore FoodStorm',
} as const

export default EN_US
